import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService, HTTPService, HelperService } from 'app/services';

import { itemTypeIcons, itemTypeLabel } from 'app/constants/itemType.constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

import { IParWarrantytHistory, IWarrantyEligible } from 'app/modules/estimate/components';
import { find, findIndex, trim } from 'lodash';

@Component({
  selector: 'app-warranty-assign-dialog',
  templateUrl: './warranty-assign-dialog.component.html',
  styleUrls: ['./warranty-assign-dialog.component.scss'],
})
export class WarrantyAssignDialogComponent implements OnInit {
  typeMap: any = itemTypeLabel;
  iconMap: any = itemTypeIcons;
  skippedItems: any = {};
  itemName: string = '';
  searchQuery: string = '';
  groupedResults: any = [];
  orderId: string = '';
  isShowMultipleAssignView: boolean = false;
  isLoading: boolean = true;
  unassignedServices: any = [];
  selectedItem: any = {};
  totalRecords: number = 0;
  pageSize: number = 100;
  originalItemObject: any = {};
  warrantyAssignedItemList: any[] = [];
  openFrom: string = '';
  isSubmitting: boolean = false;
  isAutoAssign: boolean = false;
  isFocusSearch: boolean = true;
  type: string = 'warranty';
  isWarrantyReplacementType: boolean = false;
  isWarrantyNumberAddonEnabled: boolean = false;
  isWarrantyPartType: boolean = false;
  warrantyEligible: IWarrantyEligible = {
    warrantyType: 'first-time',
    partWarrantyType: 'being-replaced',
    warrantyNumber: '',
    isSetCostPriceZero: false,
    // For Tires Only
    isSetPriceZeroOnly: false,
    disableHistory: false,
    selectedPart: {
      code: '',
      invoiceDate: '',
      partName: '',
      partNumber: '',
      warrantyNumber: '',
      _id: '',
      invoiceId: ''
    },
    itemId: '',
    serviceId: '',
    bundleId: '',
    isSkipedItem: false
  };
  error: any = {};
  currentItemId = '';
  customerId = '';
  vehicleId = '';
  partWarrantiesHistory: IParWarrantytHistory[] = [];

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private httpService: HTTPService,
    private helperService: HelperService,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
    const { isShowMultipleAssignView = false, orderId = '', itemName = '', unassignedServices = [],
      skippedItems = {}, item = {}, type = 'warranty',
      customerId = '', vehicleId = '', openFrom = '' } = this.dynamicDialogConfig.data;
    this.isShowMultipleAssignView = isShowMultipleAssignView;

    this.warrantyEligible.isSetCostPriceZero = true;
    this.warrantyEligible.isSetPriceZeroOnly = true;

    this.orderId = orderId;
    this.itemName = itemName;
    this.type = type;
    this.unassignedServices = this.getUnassignedItemsServices(unassignedServices);
    this.skippedItems = this.getUnassigedSkippedItems(skippedItems);
    this.originalItemObject = item;
    this.openFrom = openFrom;
    this.customerId = customerId;
    this.vehicleId = vehicleId;
    this.isWarrantyNumberAddonEnabled = this.dataService.isWarrantyNumberAddonEnabled;
    if (this.unassignedServices?.length) {
      if (this.unassignedServices[0]?.items?.length) {
        this.setNextSelectedItem(this.unassignedServices[0]?.items[0]);
      }
    }
    this.groupedResults = [
      { _id: 1, title: 'No Warranty', warrantyType: "not-warranty" },
      { _id: 2, title: 'First Time Installation', warrantyType: "first-time" },
      { _id: 3, title: 'Warranty Replacement', warrantyType: "replacement" }
    ];
    this.isLoading = false;
  }

  getUnassigedSkippedItems(skippedItems: any): any {
    const skippedItemsObj: any = {};
    const list = Object.values(skippedItems);
    if (list?.length) {
      list.forEach((item: any) => {
        skippedItemsObj[item.itemId] = item;
      });
    }

    return skippedItemsObj;
  }

  getUnassignedItemsServices(unassignedServices: any[]): any[] {
    let services: any[] = [];
    if (unassignedServices?.length) {
      unassignedServices?.forEach((service: any) => {
        const items = service.items.filter((item: any) => !item?.warranty?.type);
        if (items?.length) {
          services.push({
            ...service,
            items,
          });
        }
      });
    }

    return services;
  }

  handleClose(isSuccess?: boolean, data: any = {}) {
    if (this.orderId && isSuccess) {
      this.dynamicDialogRef.close({ isSuccess, data: { openFrom: this.openFrom, assignedItems: this.helperService.deepCopy(this.warrantyAssignedItemList) } });
    } else {
      this.dynamicDialogRef.close({ isSuccess });
    }
  }

  setNextSelectedItem(item: any) {
    if (!this.skippedItems[item?.itemId]?.isSkipped) {
      this.selectedItem = this.helperService.deepCopy(item);
      this.selectedItem.isSkipped = false;
    }

    const obj = {
      code: this.selectedItem.code,
      customerId: this.customerId,
      itemId: this.selectedItem.itemId,
      vehicleId: this.vehicleId
    }
    if (
      obj.itemId && obj.vehicleId && obj.customerId
    ) {
      this.getWarrantiesOrdersByItemId(obj);
    }
  }

  handleDiscardChanges() {
    if (this.warrantyAssignedItemList?.length && this.isShowMultipleAssignView) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: `Would you like to save changes?`,
          message: `There are unsaved changes here. Would you like to save them before leaving this page?`,
          button: {
            success: { title: 'Save changes and exit' },
            cancel: { title: 'Discard changes' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess }) => {
        if (isSuccess) {
          this.handleSaveAndExit();
        } else {
          this.handleClose();
        }
        onClose.unsubscribe();
      });
    } else {
      this.handleClose();
    }
  }

  setSkippedItems(item: any) {
    if (item?.itemId) {
      const itemId = item?.itemId;
      const itemsList: any = Object.values(this.skippedItems || {});
      const index = findIndex(itemsList, { itemId: itemId });

      const warrantyIndex = findIndex(this.warrantyAssignedItemList,
        { itemId: item.itemId });
      if (warrantyIndex >= 0) {
        this.warrantyAssignedItemList[warrantyIndex].warranty = {};
        this.warrantyAssignedItemList[warrantyIndex].selectedPart = {};
      }

      if (!this.skippedItems[itemId]) {
        this.skippedItems[itemId] = { ...item, isSkipped: true };
      } else {
        this.skippedItems[itemId].isSkipped = true;
      }

      const isAllMarkSkipped = itemsList?.every((item: any) => item?.isSkipped);
      if (!isAllMarkSkipped) {
        // Find the first unskipped item in the list
        const firstUnskippedItem = itemsList.find((skipItem: any) => !skipItem?.isSkipped && !skipItem.warranty?.type);
        if (firstUnskippedItem) {
          this.setNextSelectedItem(firstUnskippedItem);
        }
      } else if (isAllMarkSkipped) {
        this.selectedItem = {};
        this.handleSaveAndExit();
      }

    }
  }

  handleSelect(warrantyGroup: any, itemIndex: number) {
    let item: any = this.helperService.deepCopy(this.selectedItem);
    console.log('item', this.selectedItem);
    this.isWarrantyReplacementType = false;
    this.selectedItem.isWarrantyReplacementType = false;

    if (item.type === 'part' || item.itemType === 'part') {
      this.warrantyEligible.isSetCostPriceZero = item.isSetCostPriceZero || true;
      this.isWarrantyPartType = true;
    }

    if (item.type === 'tire' || item.itemType === 'tire') {
      this.isWarrantyPartType = false;
      this.warrantyEligible.isSetPriceZeroOnly = item.isSetPriceZeroOnly || true;
    }

    if (warrantyGroup.warrantyType === 'replacement') {

      const data = {
        ...item.warranty,
        warrantyType: warrantyGroup.warrantyType,
        replacementType: this.warrantyEligible?.partWarrantyType,
      };

      item = {
        item: this.setServiceItemWarrantyEligibleFields(item, true, data),
        isWarrantyEligible: true,
        type: this.type,
      }

      this.selectUnSelectPart(this.partWarrantiesHistory[0]);
      this.selectedItem.isWarrantyReplacementType = true;
      this.selectedItem.warranty = item?.item?.warranty;
      this.warrantyEligible.warrantyType = warrantyGroup.warrantyType;


      if (findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId }) === -1) {
        this.warrantyAssignedItemList.splice(1, 0, {
          ...item.item,
          isWarrantyEligible: true,
          type: "warranty"
        });

        const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });

        if (index >= 0 && this.partWarrantiesHistory.length === 0) {
          this.warrantyAssignedItemList[index].replacementType = 'manually-entered';
        }

      }

      if (this.partWarrantiesHistory.length > 0) {
        // Only For being replace selection selected
        this.warrantyEligible.partWarrantyType = 'being-replaced';
        this.selectUnSelectPart(this.partWarrantiesHistory[0]);
      } else {
        this.warrantyEligible.partWarrantyType = 'manually-entered';
      }

      return;
    }

    if (this.isShowMultipleAssignView) {

      if (!item.itemId) {
        return;
      }

      const serviceIdx = findIndex(this.unassignedServices, (service: any) => {
        return service?._id === this.selectedItem.serviceId;
      });
      if (serviceIdx > -1) {
        const index = findIndex(this.unassignedServices[serviceIdx]?.items, { itemId: this.selectedItem.itemId, isSkipped: false });
        if (index > -1) {
          this.unassignedServices[serviceIdx]?.items.splice(index, 1);
          delete this.skippedItems[this.selectedItem.itemId];

          if (!this.unassignedServices[serviceIdx]?.items.length) {
            this.unassignedServices.splice(serviceIdx, 1);
          }
        }
      }

      const data = {
        ...item.warranty,
        warrantyType: warrantyGroup.warrantyType,
      };

      item = {
        item: this.setServiceItemWarrantyEligibleFields(item, true, data),
        isWarrantyEligible: true,
        type: this.type,
      }

      delete item?.isSkipped;
      delete item?.itemClassificationTitle;


      const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
      if (index > -1) {
        this.warrantyAssignedItemList.splice(index, 1);
      }

      this.warrantyAssignedItemList.push(item);


      if (this.unassignedServices?.length) {
        const itemsList: any = Object.values(this.skippedItems || {});
        // Filter out items that are already in the warrantyAssignedItemList
        const unskippedItems = itemsList.filter((skipItem: any) => {
          return !skipItem.isSkipped && 
            !this.warrantyAssignedItemList.some(assignedItem => assignedItem?.item?.itemId === skipItem.itemId)
            && !skipItem.warranty?.type;
        });
        
        if (unskippedItems.length > 0) {
          // Get the first unskipped item that's not in the warrantyAssignedItemList
          this.setNextSelectedItem(unskippedItems[0]);
        } else {
          // If all remaining items are skipped or already assigned
          const anyUnskippedItem = find(itemsList, { isSkipped: false });
          if (anyUnskippedItem) {
            this.setNextSelectedItem(anyUnskippedItem);
          }
        }
      }

      if (this.warrantyAssignedItemList?.length) {
        if (!this.unassignedServices?.length) {
          this.handleSaveAndExit();
        } else if (this.unassignedServices?.length && Object.values(this.skippedItems || {})?.length) {
          //check we have any skipped items
          let onlyHasSkippedItems: boolean = true;
          this.unassignedServices.forEach((service: any) => {
            service?.items?.forEach((serviceItem: any) => {
              if (!this.skippedItems[serviceItem.itemId]?.isSkipped) {
                onlyHasSkippedItems = false;
              }
            });
          });

          if (onlyHasSkippedItems) {
            this.handleSaveAndExit();
          }
        }
      }
    }
  }

  async handleSaveAndExit() {
    let isValid = true;

    if (this.warrantyAssignedItemList?.length) {
      this.error = {};
      this.warrantyAssignedItemList.forEach(item => {
        const warranty = item?.item ? item?.item?.warranty : item?.warranty;
        if (warranty?.type === 'replacement'
          && warranty?.replacementType === 'manually-entered'
        ) {
          const { partNumber, invoiceCode, invoiceDate, warrantyNumber } = warranty?.selectedPart || {};
          if (
            !trim(partNumber) ||
            !trim(invoiceCode) || !trim(invoiceDate) || !trim(warrantyNumber)
          ) {
            isValid = false;
            // this.setNextSelectedItem(warranty);
            this.helperService.showToaster('error', 'Required fields missing');
          }

          if (!trim(invoiceCode)) {
            this.error.invoiceCode = 'Field is required';
          }

          if (!trim(partNumber)) {
            this.error.partNumber = 'Field is required';
          }

          if (!trim(warrantyNumber)) {
            this.error.warrantyNumber = 'Field is required';
          }

          if (!trim(invoiceDate)) {
            this.error.invoiceDate = 'Field is required';
          }
        }
      })

      if (isValid) {
        this.isSubmitting = true;
        try {
          const payload = this.warrantyAssignedItemList.map((item) => {
            const list = item?.item || item;
            list.cost = list.defaultCost;
            list.price = list.defaultPrice;

            if (list?.isSetCostPriceZero) {
              list.cost = 0;
              list.price = 0;
            }

            if ((list.itemType === 'tire' || list.type === 'tire') && list?.isSetPriceZeroOnly) {
              list.price = 0;
            }

            return {
              orderId: list.orderId,
              serviceId: list.serviceId,
              itemId: list?.isSubItem ? list?.parentItemId : list._id,
              subItemId: list?.isSubItem ? list._id : null,
              isWarrantyEligible: list.warranty.type === 'not-warranty' ? false : true,
              itemType: list.itemType,
              cost: list.cost ?? 0,
              price: list.price ?? 0,
              tags: list.tags ?? [],
              warranty: list.warranty ? {
                warrantySettingId: list.warranty.warrantySettingId ?? null,
                title: list.warranty.title ?? null,
                type: list.warranty.type ?? null,
                partWarrantyType: list.warranty.partWarrantyType,
                previousWarrantyNumber: ['being-replaced', 'manually-entered'].includes(list.replacementType) ? (list.warrantyNumber || list.selectedPart?.warrantyNumber) : '',
                replacementType: list.replacementType || '',
                replacementInvoice: list.selectedPart ?? {
                  partName: null,
                  partNumber: null,
                  invoiceDate: null,
                  invoiceId: null,
                  invoiceCode: null
                }
              } : null
            }
          }
          );
          await this.httpService.assignWarrantyToServiceItems(payload, this.orderId);
        } catch (error) {
          this.helperService.showToaster('error', error);
        } finally {
          this.isSubmitting = false;
          this.handleClose(true);
        }
      }
    } else {
      this.handleClose(true);
    }

  }

  getPartWarrantyHistoryEmptyObject(): IParWarrantytHistory {
    return {
      code: '',
      invoiceDate: '',
      partName: '',
      partNumber: '',
      warrantyNumber: '',
      _id: '',
      invoiceId: ''
    };
  }

  getWarrantiesOrdersByItemId(data: any) {
    this.isLoading = true;

    this.httpService.getWarrantiesOrdersByItemId(data).then(
      (res: any) => {
        this.partWarrantiesHistory = res?.length ? res : [];
        this.warrantyEligible.disableHistory = !this.partWarrantiesHistory.length;

        if (this.partWarrantiesHistory.length === 1) {
          this.selectUnSelectPart(this.partWarrantiesHistory[0]);
        } else {
          this.warrantyEligible.partWarrantyType = 'manually-entered';
        }

        const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
        if (index > -1) {
          const item = this.warrantyAssignedItemList[index];
          this.warrantyEligible = {
            ...this.warrantyEligible,
            partWarrantyType: item.replacementType || this.warrantyEligible?.partWarrantyType,
            warrantyType: item.warranty.type,
            selectedPart: item.selectedPart,
            replacementInvoice: item.selectedPart
          };

          if (item.warranty.type === 'replacement') {
            this.selectedItem.isWarrantyReplacementType = true;
          }

          if (item.type === 'part' || item.itemType === 'part') {
            this.warrantyEligible.isSetCostPriceZero = item.isSetCostPriceZero;
            this.isWarrantyPartType = true;
          }

          if (item.type === 'tire' || item.itemType === 'tire') {
            this.isWarrantyPartType = false;
            this.warrantyEligible.isSetPriceZeroOnly = item.isSetPriceZeroOnly;
          }

        }
      },
      (err: any) => {
        this.helperService.showToaster('error', err);
      }
    ).finally(() => {
      this.isLoading = false;
    });
  }

  selectUnSelectPart(part: IParWarrantytHistory) {
    this.warrantyEligible.selectedPart = this.helperService.deepCopy(part);
    if (this.warrantyAssignedItemList.length > 0) {
      const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
      if (index >= 0) {
        this.warrantyAssignedItemList[index].selectedPart = this.helperService.deepCopy(part);
        this.warrantyAssignedItemList[index].replacementType = 'being-replaced';
      }
    }
  }

  handleChange(key: string, event: any) {
    this.warrantyEligible[key] = event;
    this.error = {};
    if (event === 'manually-entered') {
      this.warrantyEligible.selectedPart = this.getPartWarrantyHistoryEmptyObject();
      const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
      if (index > -1) {
        this.warrantyAssignedItemList[index].replacementType = event;
        this.warrantyAssignedItemList[index].selectedPart = this.getPartWarrantyHistoryEmptyObject();
      }

    } else if (['being-replaced', 'replacement'].includes(event)
      &&
      this.partWarrantiesHistory?.length
    ) {
      this.selectUnSelectPart(this.partWarrantiesHistory[0]);
    }

    if (this.warrantyEligible?.partWarrantyType !== 'manually-entered') {
      this.error.warrantyNumber = '';
      this.warrantyEligible.warrantyNumber = '';
    }

    if (key === 'isSetPriceZeroOnly' || key === 'isSetCostPriceZero') {
      const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
      if (index > -1) {
        this.warrantyAssignedItemList[index][key] = event;
      }
    }
  }

  setServiceItemWarrantyEligibleFields(serviceItem: any, isSuccess: boolean, data: any) {

    serviceItem.tags.push({
      color: '#3D7EAD',
      name: 'Warranty',
      tagType: 'partWarranties',
      tooltip: `Warranty`,
    });

    const index = findIndex(serviceItem.tags, { tagType: 'partWarranties' });
    if (isSuccess && data) {
      if (serviceItem?.warranty) {
        serviceItem.warranty.type = data?.warrantyType;
        serviceItem.itemType = serviceItem.type;
        serviceItem.defaultPrice = serviceItem.price;
        serviceItem.defaultCost = serviceItem.cost;
      }
      if (data?.warrantyType === 'first-time') {
        if (index > -1) {
          serviceItem.tags[index].name = 'Warranty (First Install)';
          serviceItem.tags[index].tooltip = 'Warranty (First Install)';
        }
      } else if (data?.warrantyType === 'replacement') {
        serviceItem.warranty.replacementType = data?.replacementType || this.warrantyEligible?.partWarrantyType;
        if (index > -1) {
          serviceItem.tags[index].name = 'Warranty (Replacement)';
          serviceItem.tags[index].tooltip = 'Warranty (Replacement)';
        }

        if (data?.partWarrantyType === 'being-replaced') {
          if (data?.selectedPart?.warrantyNumber) {
            serviceItem.warranty.previousWarrantyNumber = data?.selectedPart?.warrantyNumber;
          }

          if (data?.selectedPart?._id) {
            serviceItem.warranty.replacementInvoice = {
              partName: data?.selectedPart?.partName,
              partNumber: data?.selectedPart?.partNumber,
              invoiceDate: data?.selectedPart?.invoiceDate,
              invoiceId: data?.selectedPart?.invoiceId || '',
              invoiceCode: data?.selectedPart?.code,
            };
          }
        } else if (data?.partWarrantyType === 'manually-entered') {
          if (data?.warrantyNumber) {
            serviceItem.warranty.previousWarrantyNumber = data?.warrantyNumber;
            serviceItem.warranty.replacementInvoice = {
              partName: data?.selectedPart?.partName,
              partNumber: data?.selectedPart?.partNumber,
              invoiceDate: data?.selectedPart?.invoiceDate,
              // invoiceId: data?.selectedPart?.invoiceId || '67b5c6c7eb837a708bbce869',
              invoiceCode: data?.selectedPart?.code,
            };
          }
        }

        if (serviceItem.itemType === 'part') {
          serviceItem.cost = 0;
          serviceItem.price = 0;
          serviceItem.isSetCostPriceZero = this.warrantyEligible?.isSetCostPriceZero;
        }

        // Tires only
        if (serviceItem.itemType === 'tire') {
          serviceItem.price = 0;
          serviceItem.isSetPriceZeroOnly = this.warrantyEligible?.isSetPriceZeroOnly;
        }
      } else if (data?.warrantyType === 'not-warranty') {
        serviceItem.warranty.type = data?.warrantyType;
        serviceItem.isWarrantyEligible = false;
      }
      else {
        if (index > -1) {
          serviceItem.tags.splice(index, 1);
        }
      }
    }


    return serviceItem || {}
  }

  handleManualWarranty(event: any) {
    this.selectedItem.selectedPart = event.selectedPart;
    this.warrantyEligible = { ...this.warrantyEligible, ...event };
    const index = findIndex(this.warrantyAssignedItemList, { itemId: this.selectedItem.itemId });
    if (index > -1) {
      this.warrantyAssignedItemList[index].selectedPart = event.selectedPart;
      this.warrantyAssignedItemList[index].replacementType = event.partWarrantyType;
    }
  }

}
